const taxFiling: any = {
  // 报税国家一览
  getFilingNations: [
    "get",
    "/api/filing/nations",
    {
      expect: (res: any) => _.isArray(res),
      initialVal: []
    }
  ],
  // 报税国家信息
  getNationList: [
    "get",
    "/api/filing/nationNameList",
    {
      expect: (res: any) => _.isArray(res),
      initialVal: []
    }
  ],
  // 获取申请记录
  getAppliesList: [
    'get',
    '/api/common/applies',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {
        total: 0,
        records: []
      },
      showError: false
    }
  ],
  // 获取申请记录详情
  getDetail: [
    'get',
    '/api/filing/applies/{applyNo}',
    {
      expect: (res: any) => _.isObject(res),
      initialVal: {}
    }
  ],
  // 获取支持的国家
  getNations: [
    'get',
    '/api/common/nations',
    {
      expect: (res: any) => _.isArray(res),
      initialVal: []
    }
  ],
  // 获取注册费用
  getPoundage: [
    'get',
    '/api/common/poundage',
    {
      expect: (res: any) => _.isArray(res),
      initialVal: []
    }
  ],
  // 获取店铺列表
  getStoreList: [
    'get',
    '/api/filing/stores',
    {
      expect: (res: any) => _.isArray(res),
      initialVal: []
    }
  ],
  // 提交申请材料
  submitApplies: [
    'post',
    '/api/filing/applies',
    {
      expect: (res: any) => res,
      initialVal: false
    }
  ],
   // 注册、报税订单提交
   taxSubmit: [
    "post",
    "/api/pay/register-tax-filing/submit",
    {
      expect: (res: any) => res,
      initialVal: false
    }
  ],
};

export default taxFiling;
